// Public entry point for division scoresheet PDFs.
import { buildScoresheetDoc } from './builders';
import { saveDoc, scoresheetFilename, ScoresheetData } from './pdfCommon';

export interface ScoresheetVariant {
  id: string;
  label: string;
}

// Which download options each division format offers. Round-robin ships two
// (the sample layout + an alternative cross-table); every other format has one.
export const SCORESHEET_VARIANTS: Record<string, ScoresheetVariant[]> = {
  'round-robin': [
    { id: 'standard', label: 'Standard (sample layout)' },
    { id: 'matrix', label: 'Alternative (cross-table)' },
  ],
  'round-robin-playoffs': [{ id: 'standard', label: 'Round Robin + Playoffs' }],
  bracket: [{ id: 'standard', label: 'Bracket' }],
  'pool-play': [{ id: 'standard', label: 'Pool Play' }],
  'pool-play-playoffs': [{ id: 'standard', label: 'Pool Play + Playoffs' }],
  playoffs: [{ id: 'standard', label: 'Playoffs Bracket' }],
  'playoffs-consolation': [{ id: 'standard', label: 'Playoffs + Consolation Bracket' }],
};

const FORMAT_LABELS: Record<string, string> = {
  'round-robin': 'Round Robin',
  'round-robin-playoffs': 'Round Robin Playoffs',
  bracket: 'Bracket',
  'pool-play': 'Pool Play',
  'pool-play-playoffs': 'Pool Play Playoffs',
  playoffs: 'Playoffs',
  'playoffs-consolation': 'Playoffs Consolation',
};

export function hasScoresheet(format?: string | null): boolean {
  return !!format && !!SCORESHEET_VARIANTS[format];
}

// Build + download the scoresheet for the given format/variant.
export function generateScoresheet(format: string, variantId: string, data: ScoresheetData): void {
  const doc = buildScoresheetDoc(format, variantId, data);
  const fmtLabel = FORMAT_LABELS[format] || 'Scoresheet';
  const multi = (SCORESHEET_VARIANTS[format]?.length || 0) > 1;
  const suffix = multi ? ` (${variantId})` : '';
  saveDoc(doc, scoresheetFilename(data?.division?.name, fmtLabel + suffix));
}
